import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { ISalesByDay } from "src/types/reports";

const colors = ["#0075FF", "#16AA75", "#A155B9", "#CC9C33"];

const TotalCarsChart = ({ data }: { data: ISalesByDay[] }) => {
  const theme = useTheme();
  const matchesMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  const xAxisLabels: any = [];
  const carsArr: any = [];

  data?.forEach((item) => {
    xAxisLabels.push(item.date);
    carsArr.push(item.totalTickets);
  });

  const series = [
    {
      name: "Total Cars",
      data: carsArr,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    theme: {
      mode: "dark",
    },
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    colors: colors,
    chart: {
      redrawOnParentResize: true,
      type: "line",
      zoom: {
        enabled: false,
      },
      foreColor: "#f0f0f0",
      background: "#242424",
      toolbar: {
        show: false, // Hide the download icons
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 3, // Adjust the size of the marker
      shape: "circle",
      strokeColors: colors,
    },
    stroke: {
      width: 2.5,
      curve: "straight",
    },
    grid: {
      show: true,
      borderColor: "#000",
    },
    xaxis: {
      categories: xAxisLabels,
      labels: {
        show: false,
      },
    },
    legend: {
      show: true,
      fontSize: "13.3px",
      markers: {
        width: 8,
        height: 8,
        strokeWidth: 0,
        radius: 0,
      },
      itemMargin: {
        horizontal: matchesMediumUp ? 15 : 5,
        vertical: 5,
      },
    },
  };

  return (
    <Box
      borderRadius={"12px"}
      overflow={"hidden"}
      pb={"10px"}
      bgcolor={"#242424"}
    >
      <Box padding={"21px 24px"} bgcolor={"#242424"}>
        <Typography fontSize={"20px"} fontWeight={700}>
          Total Cars
        </Typography>
      </Box>
      <Box height={"2px"} bgcolor={"#000000"} />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
        width={"100%"}
      />
    </Box>
  );
};

export default TotalCarsChart;
